'use strict';

import { initAmountPreview } from './amount-preview.js';
import { initOfferCountryRules } from './offer-country-rules.js';
import { initRecipientToggle } from './recipient-toggle.js';
import { initVineStockOrderFormValidation } from './validation.js';

const FORM_SELECTOR = [
    '[data-vine-stock-order-form] form',
    '.vine-stock-order-form form',
    '.jf-site-content-vinestockorderform .neos-form-builder-content-form form',
].join(', ');

/**
 * Formulaire de commande de cep de vigne : affichage conditionnel du propriétaire
 * et validation côté client.
 */
export function initVineStockOrderForm() {
    const forms = document.querySelectorAll(FORM_SELECTOR);
    if (!forms.length) {
        return;
    }

    forms.forEach((form) => {
        if (!(form instanceof HTMLFormElement)) {
            return;
        }

        const root =
            form.closest('[data-vine-stock-order-form]') ||
            form.closest('.vine-stock-order-form') ||
            form.closest('.jf-site-content-vinestockorderform');

        initRecipientToggle(root, form);
        initOfferCountryRules(root, form);
        initAmountPreview(root, form);
        initVineStockOrderFormValidation(form);
    });
}
